var map = {
	"./amazon/category-image.png": 5349,
	"./apple/category-image.png": 9459,
	"./ebay/category-image.png": 7864,
	"./googleplay/category-image.png": 204,
	"./netflix/category-image.png": 5839,
	"./playstation/category-image.png": 3713,
	"./steam/category-image.png": 8647,
	"./xbox/category-image.png": 3916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5886;